<template>
  <div class="wh-block sclass">
    <h2 class="uk-margin-bottom">Класс: {{ item.title }}</h2>
    <back></back>
    <h3 v-if="item.teacher">Преподаватель: {{ item.teacher.name }}</h3>

    <!--<div class="current_lesson" v-if="item.params && item.params.current_lesson">
      <h4>Задание классу:</h4>
      <div v-html="item.params.current_lesson"></div>
    </div>-->
    <h3>Ученики класса:</h3>
    <div class="sclass__sort">
      <span>Сортировать:</span>
      <a v-for="(val, key) in sort_variants" :key="val.id" href="#" :class="sort_by === key ? 'active' : ''" @click.prevent="checkSort(key)">{{ val }}
      <span v-if="sort_by === key">{{ direction }}</span>
      </a>
    </div>
    <ul class="wh-block__items">
      <li v-for="item in sortedUsers" class="sclass__item" :key="item.id">
        <div class="sclass__name">{{ item.name }}<span v-if="item.age"><i>,</i> {{ item.age }} лет</span></div>
        <div class="sclass__badges">
          <div class="sclass__scores sclass__badge" uk-tooltip="Баллов">
            <img src="storage/app/media/star.svg" alt=""> {{ item.scores }}
          </div>
          <div class="sclass__coins sclass__badge" uk-tooltip="Баланс коинов">
            <img src="storage/app/media/coin.svg" alt=""> {{ item.coin_balance }}
          </div>
          <div class="sclass__coins sclass__badge" uk-tooltip="Всего заработано коинов">
            <img src="storage/app/media/coin.svg" alt=""><img src="storage/app/media/coin.svg" alt=""> {{ item.coins_count }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "class",
  data() {
    return {
      item: '',
      sort_direction: 'desc',
      sort_by: '',
      sort_variants: {
        'scores': 'Баллы',
        'coin_balance': 'Остаток коинов',
        'coins_count': 'Всего коинов'
      }
    }
  },
  watch: {
    //'sort_by': 'checkSort'
  },
  inject: ['http'],
  computed: {
    sortedUsers() {
      let users = this.item.students;
      if (this.sort_by) {
        return _.orderBy(users, this.sort_by, this.sort_direction);
      }
      return users;
    },
    direction() {
      return this.sort_direction === 'asc' ? '↑' : '↓';
    },
  },
  methods: {
    getClass() {
      let id = this.$route.params.id;

      this.http.post('onGetStudentClass', { id }).then(res => {
        this.item = res.data
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error')) 
    },
    checkSort(val) {
      if (this.sort_by === val) {
        this.changeDirection();
      } else {
        this.sort_by = val;
      }
    },
    changeDirection() {
      this.sort_direction = this.sort_direction === 'asc' ? 'desc' : 'asc';
    },
    isActive(val) {
      return this.sort_direction === val;
    }
  },
  mounted() {
    this.getClass();
  }
}
</script>